module.exports = __webpack_public_path__ + "static/media/REVISEDORDINANCEPhD.b50a4887.pdf";